export const CHARACTER_WITH_DASH =
  /^(?=\S*[\p{L}\p{M}])\p{L}+(?:[-']\p{L}+)*(?:\s\p{L}+(?:[-']\p{L}+)*?)*$/u;
export const NUMBER_ONLY = /^\d+$/;
export const EMAIL_REGEX =
  /^[a-zA-ZÀ-ža-zA-Z0-9._%+-]+@[a-zA-ZÀ-ža-zA-Z0-9.-]+\.[a-zA-ZÀ-ža-zA-Z]{2,17}$/;
